export function ArticleTypeIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.33317 1.51294V4.26663C9.33317 4.64 9.33317 4.82669 9.40583 4.96929C9.46975 5.09473 9.57174 5.19672 9.69718 5.26064C9.83978 5.3333 10.0265 5.3333 10.3998 5.3333H13.1535M9.33317 11.3333H5.33317M10.6665 8.66659H5.33317M13.3332 6.65874V11.4666C13.3332 12.5867 13.3332 13.1467 13.1152 13.5746C12.9234 13.9509 12.6175 14.2569 12.2412 14.4486C11.8133 14.6666 11.2533 14.6666 10.1332 14.6666H5.8665C4.7464 14.6666 4.18635 14.6666 3.75852 14.4486C3.3822 14.2569 3.07624 13.9509 2.88449 13.5746C2.6665 13.1467 2 12.5867 2 11.4666V4.53325C2 3.41315 2.6665 2.85309 2.88449 2.42527C3.07624 2.04895 3.3822 1.74299 3.75852 1.55124C4.18635 1.33325 4.7464 1.33325 5.8665 1.33325H8.00769C8.49687 1.33325 8.74146 1.33325 8.97163 1.38851C9.17571 1.43751 9.3708 1.51831 9.54974 1.62797C9.75157 1.75166 9.92453 1.92461 10.2704 2.27051L12.3959 4.39599C12.7418 4.7419 12.9148 4.91485 13.0385 5.11668C13.1481 5.29563 13.2289 5.49072 13.2779 5.69479C13.3332 5.92496 13.3332 6.16955 13.3332 6.65874Z"
        stroke="currentColor"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

ArticleTypeIcon.displayName = 'ArticleTypeIcon';